// import React, { useContext, useEffect, useRef, useState } from 'react';
// import "./CreatePRopesoal.css";
// import Application from '../../../StateContext/Application.js';
// import { Back32, Cancel32, ProposalCreation32, submit } from '../../../../../public/LoginImages/importimages.js';
// import { useNavigate } from 'react-router-dom';
// import { useLanguage } from '../../../../../lang/langcontext/LanguageContext.js';

// const CreateProposal = () => {
//     const submitLockRef = useRef(false);
//     const { language, toggleLanguage, t } = useLanguage();
//     const operation = useContext(Application);
//     const { ProposalCreation, GetBudgetHeadInfo, GetAllSchemes, CreateMapCoordinateforProposal, GetGramPanchayatCodes, TypesOfWork } = operation;
//     const [HeadInfo, setHeadInfo] = useState([]);
//     const [Taluka, setTaluka] = useState([]);
//     const [Scheme, setScheme] = useState([]);
//     const [diableChoosebutton, setDisableChoosebutton] = useState(false);
//     const [locationData, setLocationData] = useState(null);
//     const [gramPanchayat, setgramPanchayat] = useState([])
//     const [GPname, setGPname] = useState([])
//     const nav = useNavigate();

//     const [tableData, setTableData] = useState([]);
//     const [editIndex, setEditIndex] = useState(null);
//     const [Indexofediting, setIndexofEditing] = useState(null);
//     const [isSubmitting, setIsSubmitting] = useState(false);

//     const [data, setData] = useState({
//         HeadCode: "3054-2419(Roads and bridge repair maintenance program)",
//         ProposalYear: "",
//         SchemeName: "",
//         District: "",
//         Taluka: "",
//         ConstituencyName: "",
//         TalukaSelection: "",
//         GramPanchayat: [],
//         WorkName: "",
//         TotalProposalAmount: "",
//         ProposalAmount: "",
//         ProposalFileNumber: "",
//         Area: "",
//         Type: "District",
//         workType: '',
//         isMultipleGp: '',
//         Remark: "",
//         workClass: "",
//         RoadCategory: "",
//         RoadNumber: "",
//         ProposalWorkAmount: "",
//         proposedLength: ''
//     });

//     const [loading, setLoading] = useState(false);
//     const [getWork, setWork] = useState([]);
//     const [WorkId, setWorkId] = useState([]);
//     const [showPopup, setShowPopup] = useState(false);

//     const HandleChangeData = (e) => {
//         let { name, value } = e.target;

//         if (value.length === 1 && value[0] === " ") return;
//         // Allow English + Marathi + numbers + space
//         //   value = value.replace(/[^a-zA-Z0-9\u0900-\u097F\s]/g, "");

//         if (name === "Taluka") {
//             const [ULBName, District] = value.split("|");
//             setData(prev => ({
//                 ...prev,
//                 Taluka: ULBName,
//                 District: District,
//                 TalukaSelection: value
//             }));
//         } else
//             if (name === "ProposalAmount") {
//                 setData(prev => ({
//                     ...prev,
//                     ProposalAmount: value
//                 }));
//                 return;
//             } else
//                 if (name === "ProposalYear") {
//                     setData(prev => ({
//                         ...prev,
//                         ProposalYear: value
//                     }));
//                     return;
//                 } else {
//                     setData(prev => ({
//                         ...prev,
//                         [name]: value
//                     }));
//                 }

//     };

//   const handleFileUpload = (file) => {
//   if (!file) return;

//   const allowedTypes = [
//     "application/pdf",
//     "image/jpeg",
//     "image/jpg",
//     "image/png",
//   ];

//   if (!file.type || !allowedTypes.includes(file.type)) {
//     alert("Only PDF, JPG, JPEG, PNG files are allowed");
//     return;
//   }

//   const cleanedFileName = file.name.replace(/\s+/g, "_");

//   return new File([file], cleanedFileName, {
//     type: file.type,
//     lastModified: file.lastModified,
//   });
// };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         // 🚫 HARD LOCK – prevents double submit even on slow network
//         if (submitLockRef.current) return;
//         submitLockRef.current = true;

//         // Optional UI state
//         setIsSubmitting(true);
//         setLoading(true);

//         try {
//             // 🔍 validations
//             data.WorkName = data.WorkName?.trim();
//             data.ProposalFileNumber = data.ProposalFileNumber?.trim();
//             data.HeadCode = data.HeadCode?.trim();

//             let ProposalCopy = document.getElementById("ProposalCopy").files;
//             let AdditionalSupportingDocument =
//                 document.getElementById("AdditionalSupportingDocument").files;

//             if (
//                 !data.HeadCode ||
//                 !data.ProposalYear ||
//                 !data.District ||
//                 !data.Taluka ||
//                 !data.ConstituencyName ||
//                 !data.TalukaSelection ||
//                 !data.GramPanchayat ||
//                 !data.ProposalFileNumber ||
//                 ProposalCopy.length === 0 ||
//                 AdditionalSupportingDocument.length === 0
//             ) {
//                 alert("Data Missing , Fill All Data !!!!");
//                 submitLockRef.current = false;
//                 setIsSubmitting(false);
//                 setLoading(false);
//                 return;
//             }

//             if (!tableData || tableData.length === 0) {
//                 alert("No Work Added !! Add Work");
//                 submitLockRef.current = false;
//                 setIsSubmitting(false);
//                 setLoading(false);
//                 return;
//             }

//             const formData = new FormData();
//             for (const key in data) {
//                 formData.append(key, data[key]);
//             }

//             formData.append("ProposalCopy", ProposalCopy[0]);
//             formData.append(
//                 "AdditionalSupportingDocument",
//                 AdditionalSupportingDocument[0]
//             );
//             formData.append("WorkTableData", JSON.stringify(tableData));
//             formData.append("ActionType", "CreateProposal");

//             const result = await ProposalCreation(formData);

//             alert(result);

//             // 🔒 KEEP LOCKED → reload will reset page anyway
//             window.location.reload();

//         } catch (err) {
//             console.error(err);
//             alert("Error While Submitting");

//             // 🔓 unlock ONLY on error
//             submitLockRef.current = false;
//             setIsSubmitting(false);
//             setLoading(false);
//         }
//     };

//     const FetchHeadInfo = async () => {
//         try {
//             let res = await GetBudgetHeadInfo("null", "all");
//             console.log("Data i get from Bakcend :: ", res);
//             setHeadInfo(res);
//         }
//         catch (err) {
//             console.log(err);
//         }
//     }

//     const FetchTalukaInfo = async () => {
//         try {
//             let res = await GetBudgetHeadInfo("null", "GetTalukas");
//             console.log("Data i get:: ", res)
//             setTaluka(res);
//         }
//         catch (err) {
//             console.log(err);
//         }
//     }

//     const GetAllSchemesInfo = async () => {
//         try {
//             let res = await GetAllSchemes();
//             console.log("Data i get:: ", res)
//             setScheme(res);
//         }
//         catch (err) {
//             console.log(err);
//         }
//     }

//     const CheckCoordinateFunction = async (id, savedData) => {
//         try {
//             let res = await GetBudgetHeadInfo(id, "GetSpecificCoordinateforProposal");
//             if (res.length > 0) {
//                 console.log("Data i get form backe--------------------- ", res[0]);
//                 setDisableChoosebutton(true);
//                 setData({
//                     ...savedData,
//                     Area: res[0].Area
//                 });
//                 setLocationData(res[0]);
//             }
//             else {
//                 setDisableChoosebutton(false);
//                 setData({
//                     ...savedData
//                 });
//             }
//         }
//         catch (err) {
//             console.error(err);
//         }
//     }

//     useEffect(() => {
//         const savedFormData = sessionStorage.getItem('createProposalForm');
//         if (savedFormData) {
//             let savedData = JSON.parse(savedFormData)
//             CheckCoordinateFunction(savedData.WorkName, savedData);
//             sessionStorage.removeItem('createProposalForm');
//         }

//         FetchHeadInfo();
//         FetchTalukaInfo();
//         GetAllSchemesInfo();
//     }, []);

//     const navigatetoMap = (e) => {
//         e.preventDefault();
//         if (data.WorkName && data.HeadCode && data.District && data.ConstituencyName && data.GramPanchayat && data.ProposalFileNumber) {
//             // Save form data to sessionStorage
//             sessionStorage.setItem('createProposalForm', JSON.stringify(data));
//             nav(`/AdminDashboard/Mapfunction`);
//         } else {
//             alert("Fill Above Data !!!!");
//         }
//     };

//     const CancelMapSubmission = async () => {
//         const shouldclose = window.confirm("Are you Sure ?");
//         if (shouldclose && data.WorkName && diableChoosebutton) {
//             const payload = {
//                 WorkName: data.WorkName
//             };

//             try {
//                 if (diableChoosebutton) {
//                     const res = await CreateMapCoordinateforProposal("DeleteTechnicalCoordinateFromTable", payload);
//                     console.log(res);
//                 }

//                 const savedFormData = sessionStorage.getItem('createProposalForm');

//                 if (savedFormData) {
//                     sessionStorage.removeItem('createProposalForm');
//                 }

//                 alert("Proposal Cancelled !!");
//                 window.location.reload();
//             }
//             catch (err) {
//                 console.log(err);
//             }

//         }
//         else {
//             alert("Proposal Cancelled !!");
//             sessionStorage.removeItem('createProposalForm');
//             window.location.reload();
//         }
//     }

//     const GetVillages = async () => {
//         try {
//             const res = await fetch("https://api.data.gov.in/resource/c967fe8f-69c4-42df-8afc-8a2c98057437?api-key=579b464db66ec23bdd000001f257881c64214fe0771e79c1b568a4b6&format=json&limit=1000&filters%5BstateNameEnglish%5D=Maharashtra", {
//                 method: "GET",
//                 headers: {
//                     "accept": "application/json",
//                 },
//             })
//             console.log("Data i get:: ", res.json())
//             // setVillage(res);
//         }
//         catch (err) {
//             console.log(err);
//         }
//     }

//     const GetGramPanchayat = async () => {
//         try {
//             let res = await GetGramPanchayatCodes(GPname, "Proposal");
//             console.log(GPname);
//             console.log("Data of grampanchayat:: ", res)
//             // let GramPanchayat = res.filter((item) => item.Development_Block_Name === GPname);
//             console.log("Data of grampanchayat:: ", res);
//             setgramPanchayat(res);
//         }
//         catch (err) {
//             console.log(err);
//         }
//     }

//     const getEnglishNameOFTaluka = async () => {
//         let res = await GetBudgetHeadInfo("null", "GetTalukas");
//         let talukaNameEnglish = res.filter((item) => item.ULBNameMarathi === data.Taluka);
//         console.log("Data of taluka:: ", talukaNameEnglish);
//         if (talukaNameEnglish.length > 0) {
//             setGPname(talukaNameEnglish[0].ULBName); // English name
//         } else {
//             console.warn("No matching Taluka found for Marathi name:", data.Taluka);
//             setGPname("");
//         }
//     }

//     useEffect(() => {
//         getEnglishNameOFTaluka();
//     }, [data.Taluka]);

//     useEffect(() => {
//         if (GPname) {
//             GetGramPanchayat();
//         }
//     }, [GPname]);

//     const AddinTableOperation = (e) => {
//         e.preventDefault();

//         try {
//             console.log("Fucntion Called : ");

//             if (!data.isMultipleGp || !data.workClass || !data.workType || !data.WorkName || !data.RoadCategory || !data.RoadNumber || !data.proposedLength || data.GramPanchayat.length <= 0 || !data.ProposalAmount) {
//                 return alert("Please fill all fields before adding!");
//             }

//             if (parseFloat(data.ProposalAmount) <= 0) {
//                 alert("Enter Work Amount Greater than 0 !!");
//                 return;
//             }

//             let obj = {
//                 classOfWork: data.workClass,
//                 typeOfWork: data.workType,
//                 proposalworkname: data.WorkName,
//                 roadCategory: data.RoadCategory,
//                 roadNumber: data.RoadNumber,
//                 proposedLength: data.proposedLength,
//                 gramPanchayat: data.GramPanchayat,
//                 proposalworkamount: data.ProposalAmount,
//                 remark: data.Remark || "",
//                 isMultipleGpCode: data.isMultipleGp
//             }

//             let isDuplicate = tableData.some((entry) =>
//                 entry.classOfWork === obj.classOfWork &&
//                 entry.typeOfWork === obj.typeOfWork &&
//                 entry.proposalworkname === obj.proposalworkname &&
//                 entry.roadCategory === obj.roadCategory &&
//                 entry.roadNumber === obj.roadNumber &&
//                 entry.isMultipleGpCode === obj.isMultipleGpCode &&
//                 JSON.stringify(entry.gramPanchayat) === JSON.stringify(obj.gramPanchayat) &&
//                 Number(entry.proposalworkamount) === Number(obj.proposalworkamount) &&
//                 entry.remark === obj.remark &&
//                 entry.proposedLength === obj.proposedLength
//             );

//             if (isDuplicate) {
//                 alert("Duplicate entry !! This data already exists in the table.");
//                 return;
//             }

//             const updatedTable = [...tableData, obj];
//             setTableData(updatedTable);

//             const totalAmount = updatedTable.reduce(
//                 (sum, item) => sum + Number(item.proposalworkamount || 0),
//                 0
//             );

//             setData({
//                 ...data,
//                 workClass: "",
//                 WorkName: "",
//                 ProposalAmount: "",
//                 RoadCategory: "",
//                 RoadNumber: "",
//                 TotalProposalAmount: totalAmount,
//                 GramPanchayat: [],
//                 workType: "",
//                 Remark: "",
//                 proposedLength: ""
//             });

//             setShowPopup(false);
//         }
//         catch (err) {
//             console.log("Error :: ", err);
//         }
//     }

//     const handleEdit = (e, index) => {
//         e.preventDefault();
//         const item = tableData[index];
//         console.log("table i selected :: ", item)
//         setEditIndex(item);
//         setIndexofEditing(index);
//     };

//     const handleDelete = (e, index) => {
//         e.preventDefault();

//         const updated = tableData.filter((_, i) => i !== index);

//         // 🔥 Recalculate total after delete
//         const totalAmount = updated.reduce(
//             (sum, item) => sum + Number(item.proposalworkamount || 0),
//             0
//         );

//         setTableData(updated);

//         setData(prev => ({
//             ...prev,
//             TotalProposalAmount: totalAmount
//         }));
//     };

//     const handelchangeTablre = (e) => {
//         e.preventDefault();
//         if (
//             !editIndex?.proposalworkname?.trim() ||
//             !editIndex?.proposalworkamount?.toString().trim()
//         ) {
//             alert("Please fill value for all fields");
//             return;
//         }
//         if (Indexofediting === null || editIndex === null) return;

//         const updatedData = [...tableData];
//         updatedData[Indexofediting] = { ...editIndex };
//         setTableData(updatedData);
//         const totalAmount = updatedData.reduce(
//             (sum, item) => sum + Number(item.proposalworkamount || 0),
//             0
//         );
//         setData({
//             ...data,
//             TotalProposalAmount: totalAmount
//         });
//         console.log("Edited Row:", editIndex);
//         setEditIndex(null);
//         setIndexofEditing(null);
//     };

//     const GetTypesOfWork = async () => {
//         console.log(data.HeadCode);
//         try {
//             let res = await TypesOfWork(data.HeadCode);
//             setLoading(true);
//             setWorkId(res);
//             console.log("Type Of Work :: ", res);
//             console.log("Work Class :: ", data.workClass);

//             if (data.HeadCode == "3054-2419(Roads and bridge repair maintenance program)") {
//                 let workNames = res.filter((item) => item.Work_Type === data.workClass);
//                 console.log("Work Names :: ", workNames);
//                 setWork(workNames)
//             }
//             else {
//                 setWork(res)
//             }
//             setLoading(false);
//         } catch (err) {
//             console.log(err);
//         }
//     }

//     useEffect(() => {
//         GetTypesOfWork();
//     }, [data.HeadCode, data.workClass, data.workType]);

//     useEffect(() => {
//         setData(prev => ({ ...prev, GramPanchayat: [] }));
//         setShowPopup(false);
//     }, [data.isMultipleGp]);
//     return (
//         <>
//             <div style={{ height: '91vh', overflowY: 'auto' }}>
//                 <div className="col-12" style={{ backgroundColor: "#EFF3F8", padding: '2rem 0px 5px 0px' }}>

//                     <div className="col-12 m-auto my-5 budgetContainer">
//                         <div className="m-auto budgetElement">
//                             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '10px' }}>
//                                 <div>
//                                     <h5 className=' bg-light'><img src={ProposalCreation32} />{t("Proposal Creation")}</h5>
//                                 </div>

//                             </div>
//                             <p className='py-2 ps-1 fw-bold text-danger' style={{ backgroundColor: "#FBE7E7" }}>{t("Note : Fields marked with * are mandatory")}</p>
//                             {loading && (
//                                 <div
//                                     style={{
//                                         position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(255, 255, 255, 0.7)', backdropFilter: 'blur(4px)', zIndex: 9999,
//                                         display: 'flex', justifyContent: 'center', alignItems: 'center'
//                                     }}>
//                                     <div style={{ border: '6px solid #f3f3f3', borderTop: '6px solid #007bff', borderRadius: '50%', width: '60px', height: '60px', animation: 'spin 1s linear infinite' }} />
//                                     <style>
//                                         {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
//                                     </style>
//                                 </div>
//                             )}

//                             <div className="">
//                                 <form action="">

//                                     <div className="col-12 elements">
//                                         <div className="row">
//                                             <div className="col-5">
//                                                 <label>{t("Head Code")}<span className='text-danger fw-bold'>*</span></label>
//                                             </div>
//                                             <div className="col-7">
//                                                 <input type="text" name="HeadCode" value={data.HeadCode} className='py-2' onChange={HandleChangeData} disabled>
//                                                 </input>
//                                             </div>
//                                         </div>
//                                     </div>

//                                     <div className="col-12 elements">
//                                         <div className="row">
//                                             <div className="col-5">
//                                                 <label>{t("Proposal Year")}<span className='text-danger fw-bold'>*</span></label>
//                                             </div>
//                                             <div className="col-7">
//                                                 <select name="ProposalYear" value={data.ProposalYear} className='py-2' onChange={HandleChangeData} required>
//                                                     <option value="">{t("Select Financial Year")}</option>
//                                                     <option value="2024-2025">2024 - 2025</option>
//                                                     <option value="2025-2026">2025 - 2026</option>
//                                                 </select>
//                                             </div>
//                                         </div>
//                                     </div>

//                                     <div className="col-12 elements">
//                                         <div className="row">
//                                             <div className="col-5 my-auto">
//                                                 <label className='my-auto'>{t("Taluka")} <span className='text-danger fw-bold'>*</span></label>
//                                             </div>
//                                             <div className="col-7">
//                                                 <select name="Taluka" value={data.TalukaSelection} className='py-2' onChange={HandleChangeData} required>
//                                                     <option value="">{t("Select Taluka")}</option>
//                                                     {
//                                                         Taluka &&
//                                                         [...new Set(Taluka.map(val => val.ULBNameMarathi))].map((ULBNameMarathi, index) => {
//                                                             const district = Taluka.find(t => t.ULBNameMarathi === ULBNameMarathi)?.District_Marathi || '';
//                                                             return (
//                                                                 <option key={index} value={`${ULBNameMarathi}|${district}`}>
//                                                                     {ULBNameMarathi}
//                                                                 </option>
//                                                             )
//                                                         })
//                                                     }
//                                                 </select>
//                                             </div>
//                                         </div>
//                                     </div>

//                                     <div className="col-12 elements">
//                                         <div className="row">
//                                             <div className="col-5">
//                                                 <label>{t("Constituency Name")}<span className='text-danger fw-bold'>*</span></label>
//                                             </div>
//                                             <div className="col-7">
//                                                 <input type="text" placeholder={t("Enter Constituency Name")} className='form-control py-2' name='ConstituencyName'
//                                                     maxLength={100}
//                                                     value={data.ConstituencyName}
//                                                     onChange={(e) => {
//                                                         const value = e.target.value.replace(/[^a-zA-Z0-9\u0900-\u097F\s!@#$%^&*()_+=\-{}[\]:;"'<>,.?/\\|]/g, "")
//                                                         HandleChangeData({ target: { name: e.target.name, value } });
//                                                     }}
//                                                     required />
//                                             </div>
//                                         </div>
//                                     </div>

//                                     <div className="col-12 elements">
//                                         <div className="row">
//                                             <div className="col-5">
//                                                 <label>{t("This involves multiple Gram Panchayat?")}<span className='text-danger fw-bold'>*</span></label>
//                                             </div>
//                                             <div className="col-7" style={{ display: "flex", gap: "15px" }}>
//                                                 <div>
//                                                     <label><input type="radio" name="isMultipleGp" value="Yes" onChange={HandleChangeData} checked={data.isMultipleGp === "Yes"} /></label>
//                                                     <label>{t("Yes")}</label>
//                                                 </div>
//                                                 <div>
//                                                     <label><input type="radio" name="isMultipleGp" value="No" onChange={HandleChangeData} checked={data.isMultipleGp === "No"} /></label>
//                                                     <label>{t("No")}</label>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>

//                                     <div className="col-12 pb-5 mt-3">
//                                         <div className='col-12 ' style={{
//                                             display: 'flex',
//                                             overflowX: "auto",

//                                             width: '100%'
//                                         }}>
//                                             <table className='m-0 p-0' style={{
//                                                 width: '100%',
//                                                 borderCollapse: 'collapse'
//                                             }}>
//                                                 <thead >
//                                                     <tr style={{
//                                                         color: 'white',
//                                                         border: 'none',
//                                                         height: '3rem',
//                                                         fontSize: "14px"
//                                                     }}>
//                                                         <th style={{ padding: "7px 10px", minWidth: "200px" }}>{t("Class Of Work")}<span className='text-danger fw-bold'>*</span></th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "190px" }}>{t("Type of Work")}<span className='text-danger fw-bold'>*</span></th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "240px" }}>{t("Work Name")}<span className='text-danger fw-bold'>*</span></th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "200px" }}>{t("Road Category")}<span className='text-danger fw-bold'>*</span></th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "180px" }}>{t("Road Number")}<span className='text-danger fw-bold'>*</span></th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "180px" }}>{t("Proposed Length (in Km)")}<span className='text-danger fw-bold'>*</span></th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "180px" }}>{t("Gram Panchayat")}<span className='text-danger fw-bold'>*</span></th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "220px" }}>{t("Work Amount")}<span className='text-danger fw-bold'>*</span></th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "240px" }}>{t("Remark")}</th>
//                                                     </tr>
//                                                 </thead>

//                                                 <tbody>
//                                                     <tr>
//                                                         <td>
//                                                             <select name="workClass" id=""
//                                                                 value={data.workClass}
//                                                                 onChange={HandleChangeData}
//                                                                 className="form-select form-select-sm custom-select"
//                                                                 required
//                                                             >
//                                                                 <option value="" disabled>{t("Choose Class Of Work")}</option>
//                                                                 {WorkId && [...new Set(WorkId.map(item => item.Work_Type))].sort().map((val, index) => (
//                                                                     <option key={index} value={val}>{val || "N/A"}</option>
//                                                                 ))}
//                                                             </select>
//                                                         </td>

//                                                         <td>
//                                                             <select name="workType" id=""
//                                                                 value={data.workType}
//                                                                 onChange={HandleChangeData}
//                                                                 className="form-select form-select-sm custom-select"
//                                                                 required
//                                                             >
//                                                                 <option value="" disabled>{t("Choose Type of Work")}</option>
//                                                                 {getWork && getWork.map((val, index) => {
//                                                                     return (
//                                                                         <option key={index} value={val.Work_name}>{val.Work_name}</option>
//                                                                     )
//                                                                 })}
//                                                             </select>
//                                                         </td>
//                                                         <td>
//                                                             <input
//                                                                 type="text"
//                                                                 name="WorkName"
//                                                                 placeholder={t("Enter Work Name")}
//                                                                 className="form-control form-control-sm custom-input"
//                                                                 value={data.WorkName}
//                                                                 maxLength={200}
//                                                                 onChange={(e) => {
//                                                                     let value = e.target.value
//                                                                         .replace(/[^a-zA-Z0-9\u0900-\u097F\s!@#$%^&*()_+=\-{}[\]:;"'<>,.?/\\|]/g, "")
//                                                                         .replace(/^\s+/, "");
//                                                                     if (value.length > 500) return;

//                                                                     HandleChangeData({
//                                                                         target: { name: "WorkName", value },
//                                                                     });
//                                                                 }}
//                                                                 required
//                                                             />
//                                                         </td>

//                                                         <td><select name="RoadCategory" id=""
//                                                             value={data.RoadCategory}
//                                                             onChange={HandleChangeData}
//                                                             className="form-select form-select-sm custom-select"
//                                                             required
//                                                         >
//                                                             <option value="" disabled>{t("Choose Road Category")}</option>
//                                                             <option>{t("Village Road")}</option>
//                                                             <option>{t("Other District Road")}</option>
//                                                         </select></td>
//                                                         <td> <input
//                                                             type="text"
//                                                             name="RoadNumber"
//                                                             placeholder={t("Enter Road No")}
//                                                             className="form-control form-control-sm custom-input"
//                                                             value={data.RoadNumber}
//                                                             // onChange={HandleChangeData}
//                                                              onChange={(e) => {
//                                                                     const value = e.target.value.replace(/[^a-zA-Z0-9.\s]/g, "");
//                                                                     HandleChangeData({ target: { name: e.target.name, value } });
//                                                                 }}
//                                                             required
//                                                         /></td>
//                                                         <td>
//                                                             <input
//                                                                 type="text"
//                                                                 name="proposedLength"
//                                                                 placeholder={t("Enter Proposed Length")}
//                                                                 className="form-control form-control-sm custom-input"
//                                                                 value={data.proposedLength}
//                                                                 // onChange={(e) => {
//                                                                 //     const value = e.target.value.replace(/[^a-zA-Z0-9.\s]/g, "");
//                                                                 //     HandleChangeData({ target: { name: e.target.name, value } });
//                                                                 // }}
//                                                                    onChange={HandleChangeData}
//                                                                 required
//                                                             />
//                                                         </td>

//                                                         <td >
//                                                             <div className="col-12">
//                                                                 {
//                                                                     (showPopup == false && data.GramPanchayat.length <= 0) &&
//                                                                     <button
//                                                                         type="button"
//                                                                         onClick={() => {
//                                                                             if (!data.Taluka || !data.isMultipleGp || !data.HeadCode) {
//                                                                                 alert("Plz Fill Above Missing Data !!");
//                                                                             } else {
//                                                                                 setShowPopup(true)
//                                                                             }
//                                                                         }}
//                                                                         className='btn btn-success'
//                                                                     >
//                                                                         {t("Select Gram Panchayat")}
//                                                                     </button>
//                                                                 }

//                                                                 {
//                                                                     (data.GramPanchayat.length > 0) && (
//                                                                         <div className="col-12" style={{ overflowX: "hidden", overflowWrap: "break-word", whiteSpace: "normal" }}>
//                                                                             {data.GramPanchayat.join(", ")}
//                                                                         </div>
//                                                                     )
//                                                                 }
//                                                             </div>
//                                                         </td>

//                                                         <td>
//                                                             <input type="number" name="ProposalAmount" placeholder={t("Enter Proposal Work Amount")} className="form-control form-control-sm custom-input" min="1" max="999999999.99" step="0.01" value={data.ProposalAmount}
//                                                                 onKeyDown={(e) => {
//                                                                     if (["e", "E", "+", "-"].includes(e.key)) {
//                                                                         e.preventDefault();
//                                                                     }
//                                                                 }}
//                                                                 onChange={(e) => {
//                                                                     let value = e.target.value;
//                                                                     // Allow empty while typing
//                                                                     if (value === "") {
//                                                                         HandleChangeData(e);
//                                                                         return;
//                                                                     }
//                                                                     // Convert to number
//                                                                     let num = Number(value);
//                                                                     // Range validation
//                                                                     if (num < 1) return;
//                                                                     if (num > 999999999.99) return;
//                                                                     // Decimal places limit (2)
//                                                                     if (value.includes(".") && value.split(".")[1].length > 2) return;
//                                                                     if (!/^\d*(\.\d{0,2})?$/.test(value)) return;
//                                                                     HandleChangeData(e);
//                                                                 }}
//                                                                 required
//                                                             />
//                                                         </td>

//                                                         <td>
//                                                             <input
//                                                                 type="text"
//                                                                 name="Remark"
//                                                                 placeholder={t("Enter Remark")}
//                                                                 className="form-control form-control-sm custom-input"
//                                                                 value={data.Remark}
//                                                                 onChange={HandleChangeData}
//                                                                 required
//                                                             />
//                                                         </td>
//                                                     </tr>
//                                                 </tbody>
//                                             </table>
//                                         </div>
//                                     </div>

//                                     {
//                                         showPopup && (
//                                             <div
//                                                 style={{
//                                                     position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0, 0, 0, 0.21)', backdropFilter: 'blur(4px)', zIndex: 999,
//                                                     display: 'flex', justifyContent: 'center', alignItems: 'center'
//                                                 }}
//                                             >
//                                                 <div className="m-auto" style={{
//                                                     background: "white",
//                                                     height: '400px',
//                                                     width: "450px",
//                                                     overflowY: "auto",
//                                                     overflowX: "hidden",
//                                                     padding: "20px"
//                                                 }}>

//                                                     <div style={{ position: "relative" }}>
//                                                         <button
//                                                             onClick={handleSubmit}
//                                                             disabled={isSubmitting}
//                                                             style={{
//                                                                 display: "flex",
//                                                                 alignItems: "center",
//                                                                 justifyContent: "center",
//                                                                 gap: "4px",
//                                                                 background: isSubmitting
//                                                                     ? "#9ca3af"
//                                                                     : "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
//                                                                 width: "5rem",
//                                                                 height: "2rem",
//                                                                 fontSize: "18px",
//                                                                 cursor: isSubmitting ? "not-allowed" : "pointer",
//                                                                 opacity: isSubmitting ? 0.7 : 1,
//                                                             }}
//                                                         >
//                                                             {isSubmitting ? (
//                                                                 "Saving..."
//                                                             ) : (
//                                                                 <>
//                                                                     <img src={submit} style={{ width: "15px" }} />
//                                                                     {t("Save")}
//                                                                 </>
//                                                             )}
//                                                         </button>
//                                                         <button
//                                                             type="button"
//                                                             // onClick={() => setShowPopup(false)}
//                                                             onClick={() => {
//                                                                 setData({
//                                                                     ...data,
//                                                                     GramPanchayat: []
//                                                                 });
//                                                                 setShowPopup(false);
//                                                             }}
//                                                             style={{
//                                                                 padding: "5px 10px",
//                                                                 fontSize: "18px",
//                                                                 borderRadius: "3px",
//                                                                 border: "none",
//                                                                 backgroundColor: "#b60101",
//                                                                 color: "#fff",
//                                                                 cursor: "pointer",
//                                                                 fontWeight: "600",
//                                                                 lineHeight: "1",
//                                                                 float: "right"
//                                                             }}
//                                                             title="Close"
//                                                         >
//                                                             &times;
//                                                         </button>
//                                                     </div>

//                                                     <div className="col-12">

//                                                         <div style={{ textAlign: "center", marginTop: "20px" }}>

//                                                         </div>
//                                                         {[...new Set(gramPanchayat.map(gp => gp.Village_Panchayat_Name))].map((name, index) => (
//                                                             <div className='col-12' key={index} style={{ marginBottom: "5px", fontSize: "12px" }}>
//                                                                 <div className="row">
//                                                                     <div className="col-2 m-auto">
//                                                                         <input
//                                                                             type="checkbox"
//                                                                             id={`gp-${index}`}
//                                                                             value={name}
//                                                                             checked={data.GramPanchayat.includes(name)}
//                                                                             style={{
//                                                                                 margin: "auto"
//                                                                             }}
//                                                                             onChange={(e) => {

//                                                                                 if (data.isMultipleGp == 'No') {
//                                                                                     setData(prev => ({ ...prev, GramPanchayat: [name] }));
//                                                                                     setShowPopup(false);
//                                                                                 }
//                                                                                 else {
//                                                                                     if (e.target.checked) {
//                                                                                         if (data.GramPanchayat.length >= 5) {
//                                                                                             alert("You can select a maximum of 5 Gram Panchayats only.");
//                                                                                             setShowPopup(false);
//                                                                                             return;
//                                                                                         }
//                                                                                         setData(prev => ({ ...prev, GramPanchayat: [...prev.GramPanchayat, name] }));
//                                                                                     } else {
//                                                                                         setData(prev => ({ ...prev, GramPanchayat: prev.GramPanchayat.filter(gp => gp !== name) }));
//                                                                                     }
//                                                                                 }
//                                                                             }}
//                                                                         />
//                                                                     </div>

//                                                                     <div className="col-10 m-auto">
//                                                                         <label className='col-12 my-auto' htmlFor={`gp-${index}`}>{name}</label>
//                                                                     </div>

//                                                                 </div>
//                                                             </div>
//                                                         ))}
//                                                     </div>

//                                                 </div>
//                                             </div>
//                                         )}
//                                     <div className="col-12 text-center mb-4 mt-1">
//                                         <div className="col-10 m-auto">
//                                             <button
//                                                 type="button"
//                                                 className="btn btn-success px-4 py-1"
//                                                 onClick={AddinTableOperation}
//                                             >{t("ADD")}</button>
//                                         </div>
//                                     </div>

//                                     {
//                                         tableData && tableData.length > 0 && (
//                                             <div className="col-12 my-5" >
//                                                 <div className="row">
//                                                     <div className="col-12 tableContainer100">
//                                                         <div style={{ overflowX: "auto", maxWidth: "100%" }}>
//                                                             <table
//                                                                 className="m-0 p-0"
//                                                                 style={{
//                                                                     width: "100%",
//                                                                     borderCollapse: "collapse",
//                                                                     whiteSpace: "nowrap",
//                                                                 }}
//                                                             >
//                                                                 <thead
//                                                                     style={{
//                                                                         backgroundColor: "#f0f3f8", // 🔹 light gray-blue header
//                                                                         color: "#333",
//                                                                         height: "3rem",
//                                                                         fontSize: "14px",
//                                                                     }}
//                                                                 >
//                                                                     <tr>
//                                                                         <th style={{ padding: "7px 10px", minWidth: "40px" }}>{t("Sr.No")}</th>
//                                                                         <th style={{ padding: "7px 10px", minWidth: "170px" }}>{t("Class Of Work")}</th>
//                                                                         <th style={{ padding: "7px 10px", minWidth: "190px" }}>{t("Type of Work")}</th>
//                                                                         <th style={{ padding: "7px 10px", minWidth: "240px" }}>{t("Work Name")}</th>
//                                                                         <th style={{ padding: "7px 10px", minWidth: "170px" }}>{t("Road Category")}</th>
//                                                                         <th style={{ padding: "7px 10px", minWidth: "180px" }}>{t("Road Number")}</th>
//                                                                         <th style={{ padding: "7px 10px", minWidth: "180px" }}>{t("Proposed Length")}</th>
//                                                                         <th style={{ padding: "7px 10px", minWidth: "180px" }}>{t("Gram Panchayat")}</th>
//                                                                         <th style={{ padding: "7px 10px", minWidth: "170px" }}>{t("Work Amount")}</th>
//                                                                         <th style={{ padding: "7px 10px", minWidth: "240px" }}>{t("Remark")}</th>
//                                                                         <th style={{ padding: "7px 10px", minWidth: "180px" }}>{t("Actions")}</th>
//                                                                     </tr>
//                                                                 </thead>

//                                                                 <tbody>
//                                                                     {tableData.map((val, index) => {
//                                                                         const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                                                                         return (
//                                                                             <tr
//                                                                                 key={index}
//                                                                                 style={{
//                                                                                     backgroundColor: bgColor,
//                                                                                     height: "2.5rem",
//                                                                                     borderBottom: "1px solid #ddd",
//                                                                                 }}
//                                                                             >
//                                                                                 <td style={{ padding: "6px 10px" }}>{index + 1}</td>
//                                                                                 <td style={{ padding: "6px 10px" }}>{val.classOfWork}</td>
//                                                                                 <td style={{ padding: "6px 10px" }}>{val.typeOfWork}</td>
//                                                                                 <td style={{ padding: "6px 10px" }}>{val.proposalworkname}</td>
//                                                                                 <td style={{ padding: "6px 10px" }}>{val.roadCategory}</td>
//                                                                                 <td style={{ padding: "6px 10px" }}>{val.roadNumber}</td>
//                                                                                 <td style={{ padding: "6px 10px" }}>{val.proposedLength}</td>
//                                                                                 <td style={{ padding: "6px 10px" }}>
//                                                                                     <div
//                                                                                         className="col-12"
//                                                                                         style={{
//                                                                                             overflowX: "hidden",
//                                                                                             overflowWrap: "break-word",
//                                                                                             whiteSpace: "normal",
//                                                                                         }}
//                                                                                     >
//                                                                                         {val.gramPanchayat.join(", ")}
//                                                                                     </div>
//                                                                                 </td>
//                                                                                 <td style={{ padding: "6px 10px" }}>{val.proposalworkamount}</td>
//                                                                                 <td style={{ padding: "6px 10px" }}>{val.remark}</td>
//                                                                                 <td style={{ padding: "6px 10px" }}>
//                                                                                     <button
//                                                                                         className="btn btn-sm btn-primary mx-1"
//                                                                                         onClick={(e) => handleEdit(e, index)}
//                                                                                     >
//                                                                                         {t("Edit")}
//                                                                                     </button>
//                                                                                     <button
//                                                                                         className="btn btn-sm btn-danger mx-1"
//                                                                                         onClick={(e) => handleDelete(e, index)}
//                                                                                     >
//                                                                                         {t("Delete")}
//                                                                                     </button>
//                                                                                 </td>
//                                                                             </tr>
//                                                                         );
//                                                                     })}
//                                                                 </tbody>
//                                                             </table>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         )
//                                     }

//                                     {
//                                         editIndex &&
//                                         <div style={{
//                                             position: "fixed",
//                                             top: 0,
//                                             left: 0,
//                                             width: "100%",
//                                             height: "100%",
//                                             background: "rgba(0, 0, 0, 0.4)",
//                                             backdropFilter: "blur(6px)",
//                                             zIndex: 100,
//                                             display: "flex",
//                                             justifyContent: "center",
//                                             alignItems: "center",
//                                             animation: "fadeIn 0.3s ease-in-out",
//                                         }}>
//                                             <div className="col-6 shadow-lg rounded-4 p-4 bg-white border-0 m-auto">
//                                                 <div className="col-12 m-auto rounded p-4 border border-dark">
//                                                     <form action="">
//                                                         <div className="row">

//                                                             <div className="col-12 my-2">
//                                                                 <div className="row">
//                                                                     <div className="col-6">
//                                                                         <label>{t("Proposal Work Name")}</label>
//                                                                     </div>

//                                                                     <div className="col-6">
//                                                                         <input type="text" value={editIndex.proposalworkname}
//                                                                             onChange={(e) => {
//                                                                                 let value = e.target.value;
//                                                                                 if (value.length === 1 && value[0] === " ") return;
//                                                                                 if (value.length > 500) return;
//                                                                                 setEditIndex((prev) => ({
//                                                                                     ...prev,
//                                                                                     proposalworkname: value,
//                                                                                 }));
//                                                                             }}
//                                                                             required />
//                                                                     </div>

//                                                                 </div>
//                                                             </div>

//                                                             <div className="col-12 my-2">
//                                                                 <div className="row">
//                                                                     <div className="col-6">
//                                                                         <label>{t("Proposal Work Amount")}</label>
//                                                                     </div>
//                                                                     <div className="col-6">
//                                                                         <input type="number" value={editIndex.proposalworkamount} name="amount" min={1} step="1"
//                                                                             onKeyDown={(e) => {
//                                                                                 if (["e", "E", "+", "-", "."].includes(e.key)) { e.preventDefault(); }
//                                                                             }}
//                                                                             onChange={(e) => {
//                                                                                 const value = e.target.value;
//                                                                                 if (value === "") {
//                                                                                     setEditIndex({ ...editIndex, proposalworkamount: "", });
//                                                                                     return;
//                                                                                 }
//                                                                                 const numValue = Number(value);
//                                                                                 if (numValue < 1) { return; }
//                                                                                 setEditIndex({ ...editIndex, proposalworkamount: numValue });
//                                                                             }}
//                                                                         // onBlur={() => {
//                                                                         //     if (!editIndex.proposalworkamount || editIndex.proposalworkamount < 1
//                                                                         //     ) { setEditIndex({ ...editIndex, proposalworkamount: 1 }); }
//                                                                         // }}
//                                                                         />
//                                                                     </div>
//                                                                 </div>
//                                                             </div>

//                                                             <div className="col-12 my-4 text-center">
//                                                                 <button className='btn btn-success px-5 fw-bold' onClick={(e) => handelchangeTablre(e)}>{t("Submit")}</button>
//                                                             </div>

//                                                         </div>
//                                                     </form>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     }

//                                     <div className="col-12 elements">
//                                         <div className="row">
//                                             <div className="col-5">
//                                                 <label>{t("Proposal Amount")}</label>
//                                             </div>
//                                             <div className="col-7">
//                                                 <input type="number"
//                                                     placeholder={t("Enter Proposal Amount")}
//                                                     className='form-control py-2'
//                                                     name='TotalProposalAmount'
//                                                     min="0"
//                                                     onKeyDown={(e) => {
//                                                         if (
//                                                             ["e", "E", "+", "-"].includes(e.key) ||
//                                                             (e.key === "." && e.target.value.includes(".")) // prevent multiple dots
//                                                         ) {
//                                                             e.preventDefault();
//                                                         }
//                                                     }}
//                                                     value={data.TotalProposalAmount}
//                                                     // onChange={HandleChangeData}
//                                                     disabled />
//                                             </div>

//                                         </div>
//                                     </div>

//                                     <div className="col-12 elements">
//                                         <div className="row">
//                                             <div className="col-5">
//                                                 <label>{t("Proposal File Number")}<span className='text-danger fw-bold'>*</span></label>
//                                             </div>
//                                             <div className="col-7">
//                                                 <input type="text" placeholder={t("Enter Proposal File Number")} className='form-control py-2' name='ProposalFileNumber'
//                                                     value={data.ProposalFileNumber}
//                                                     onChange={HandleChangeData} />
//                                             </div>
//                                         </div>
//                                     </div>

//                                     <div className="col-12 elements">
//                                         <div className="row">
//                                             <div className="col-5">
//                                                 <label>{t("Proposal Copy")}<span className='text-danger fw-bold'>*</span></label>
//                                             </div>
//                                             <div className="col-7">
//                                                 <input type="file" className='form-control py-2' id='ProposalCopy' accept=".pdf,.jpg,.jpeg,.png" required onChange={(e) => handleFileUpload(e.target.files[0])} />
//                                             </div>
//                                         </div>
//                                     </div>

//                                     <div className="col-12 elements">
//                                         <div className="row">
//                                             <div className="col-5">
//                                                 <label>{t("Additional Supporting Document")}<span className='text-danger fw-bold'>*</span></label>
//                                             </div>
//                                             <div className="col-7">
//                                                 <input type="file" className='form-control py-2' id='AdditionalSupportingDocument' accept=".pdf,.jpg,.jpeg,.png" required onChange={(e) => handleFileUpload(e.target.files[0])} />
//                                             </div>
//                                         </div>
//                                     </div>

//                                     <div className="col-12 ms-auto my-4">
//                                         <div className="row">
//                                             <div className="col-5"></div>
//                                             <div className="col-7">
//                                                 <div className="col-12" style={{ display: 'flex', gap: '10px' }}>
//                                                     <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', width: '5rem', height: '2rem', fontSize: '18px' }} onClick={handleSubmit}><img src={submit} style={{ width: '15px' }} /> {t("Save")}</button>
//                                                     <button type="button"
//                                                         style={{
//                                                             display: 'flex',
//                                                             alignItems: 'center',
//                                                             justifyContent: 'center',
//                                                             gap: '4px',
//                                                             backgroundColor: '#f1594c',
//                                                             width: '6rem', height: '2rem', fontSize: '16px'
//                                                         }}
//                                                         onClick={() => CancelMapSubmission()}> <img src={Cancel32} style={{ width: '17px' }} />{t("Cancel")}</button>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </form>
//                             </div>
//                         </div>
//                     </div >
//                 </div >
//             </div>
//         </>
//     );
// };

// export default CreateProposal;

import React, { useContext, useEffect, useRef, useState } from "react";
import "./CreatePRopesoal.css";
import Application from "../../../StateContext/Application.js";
import {
  Back32,
  Cancel32,
  ProposalCreation32,
  submit,
} from "../../../../../public/LoginImages/importimages.js";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../../../../lang/langcontext/LanguageContext.js";
import validateFile from "../../../../../utils/fileUploadHelper.js";

const CreateProposal = () => {
  const submitLockRef = useRef(false);
  const { language, toggleLanguage, t } = useLanguage();
  const operation = useContext(Application);
  const {
    ProposalCreation,
    GetBudgetHeadInfo,
    GetAllSchemes,
    CreateMapCoordinateforProposal,
    GetGramPanchayatCodes,
    TypesOfWork,CheckWorkNameDuplicate,
 
  } = operation;
  const [HeadInfo, setHeadInfo] = useState([]);
  const [Taluka, setTaluka] = useState([]);
  const [Scheme, setScheme] = useState([]);
  const [diableChoosebutton, setDisableChoosebutton] = useState(false);
  const [locationData, setLocationData] = useState(null);
  const [gramPanchayat, setgramPanchayat] = useState([]);
  const [GPname, setGPname] = useState([]);
  const nav = useNavigate();

  const [tableData, setTableData] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [Indexofediting, setIndexofEditing] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [data, setData] = useState({
    HeadCode: "3054-2419(Roads and bridge repair maintenance program)",
    ProposalYear: "",
    SchemeName: "",
    District: "",
    Taluka: "",
    ConstituencyName: "",
    TalukaSelection: "",
    GramPanchayat: [],
    WorkName: "",
    JobId: "",
    TotalProposalAmount: "",
    ProposalAmount: "",
    ProposalFileNumber: "",
    Area: "",
    Type: "District",
    workType: "",
    isMultipleGp: "",
    Remark: "",
    workClass: "",
    RoadCategory: "",
    RoadNumber: "",
    ProposalWorkAmount: "",
    proposedLength: "",
  });

  const [loading, setLoading] = useState(false);
  const [getWork, setWork] = useState([]);
  const [WorkId, setWorkId] = useState([]);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const preventWheel = (e) => {
      if (document.activeElement.type === "number") {
        document.activeElement.blur();
      }
    };
    window.addEventListener("wheel", preventWheel, { passive: true });
    return () => window.removeEventListener("wheel", preventWheel);
  }, []);

  const HandleChangeData = (e) => {
    let { name, value } = e.target;

    if (value.length === 1 && value[0] === " ") return;
    //   value = value.replace(/\s+/, "");
    // Allow English + Marathi + numbers + space
    //   value = value.replace(/[^a-zA-Z0-9\u0900-\u097F\s]/g, "");

    if (name === "Taluka") {
      const [ULBName, District] = value.split("|");
      setData((prev) => ({
        ...prev,
        Taluka: ULBName,
        District: District,
        TalukaSelection: value,
      }));
    } else if (name === "ProposalAmount") {
      setData((prev) => ({
        ...prev,
        ProposalAmount: value,
      }));
      return;
    } else if (name === "ProposalYear") {
      setData((prev) => ({
        ...prev,
        ProposalYear: value,
      }));
      return;
    } else if (name === "JobId") {
      console.log("job id...", value);
      setData((prev) => ({
        ...prev,
        JobId: value,
      }));
      return;
    } else {
      setData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };
const hasDuplicateWorkName = async (workName) => {
    const trimmedName = workName?.trim();
    if (!trimmedName) {
      alert("Work Name is required.");
      return true;
    }
 
    try {
      const result = await CheckWorkNameDuplicate(
        trimmedName,
        "Proposal",
      );
      if (result?.isDuplicate) alert(result.message);
      return Boolean(result?.isDuplicate);
    } catch (err) {
      alert(err?.message || "Unable to validate Work Name");
      return true;
    }
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const validation = validateFile(file, 2);
 
    if (!validation.valid) {
      alert(validation.message);
      e.target.value = "";
      return;
    }

    const cleanedFileName = file.name.trim().replace(/\s+/g, "");
    console.log("cln file", cleanedFileName.lastModified);
    return new File([file], cleanedFileName, {
      type: file.type,
      lastModified: file.lastModified,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 🚫 HARD LOCK – prevents double submit even on slow network
    if (submitLockRef.current) return;
    submitLockRef.current = true;

    // Optional UI state
    setIsSubmitting(true);
    setLoading(true);

    try {
      // 🔍 validations
      data.WorkName = data.WorkName?.trim();
      data.ProposalFileNumber = data.ProposalFileNumber?.trim();
      data.HeadCode = data.HeadCode?.trim();

      let ProposalCopy = document.getElementById("ProposalCopy").files;
      let AdditionalSupportingDocument = document.getElementById(
        "AdditionalSupportingDocument",
      ).files;

      if (
        !data.HeadCode ||
        !data.ProposalYear ||
        !data.District ||
        !data.Taluka ||
        !data.ConstituencyName ||
        !data.TalukaSelection ||
        !data.GramPanchayat ||
        !data.ProposalFileNumber ||
        ProposalCopy.length === 0 ||
        AdditionalSupportingDocument.length === 0
      ) {
        console.log("datamissing", data);
        alert("Data Missing , Fill All Data !!!!");
        submitLockRef.current = false;
        setIsSubmitting(false);
        setLoading(false);
        return;
      }

      if (!tableData || tableData.length === 0) {
        alert("No Work Added !! Add Work");
        submitLockRef.current = false;
        setIsSubmitting(false);
        setLoading(false);
        return;
      }
      if (error) {
        alert(error);
        return; // 🚫 stop submission
      }
      const formData = new FormData();
      for (const key in data) {
        formData.append(key, data[key]);
      }

      formData.append("ProposalCopy", ProposalCopy[0]);
      formData.append(
        "AdditionalSupportingDocument",
        AdditionalSupportingDocument[0],
      );
      formData.append("WorkTableData", JSON.stringify(tableData));
      formData.append("ActionType", "CreateProposal");

      const result = await ProposalCreation(formData);

      alert(result);

      // 🔒 KEEP LOCKED → reload will reset page anyway
      window.location.reload();
    } catch (err) {
      console.error(err);
      alert("Error While Submitting");

      // 🔓 unlock ONLY on error
      submitLockRef.current = false;
      setIsSubmitting(false);
      setLoading(false);
    }
  };

  const FetchHeadInfo = async () => {
    try {
      let res = await GetBudgetHeadInfo("null", "all");
      console.log("Data i get from Bakcend :: ", res);
      setHeadInfo(res);
    } catch (err) {
      console.log(err);
    }
  };

  const FetchTalukaInfo = async () => {
    try {
      let res = await GetBudgetHeadInfo("null", "GetTalukas");
      console.log("Data i get:: ", res);
      setTaluka(res);
    } catch (err) {
      console.log(err);
    }
  };

  const GetAllSchemesInfo = async () => {
    try {
      let res = await GetAllSchemes();
      console.log("Data i get:: ", res);
      setScheme(res);
    } catch (err) {
      console.log(err);
    }
  };

  const CheckCoordinateFunction = async (id, savedData) => {
    try {
      let res = await GetBudgetHeadInfo(id, "GetSpecificCoordinateforProposal");
      if (res.length > 0) {
        console.log("Data i get form backe--------------------- ", res[0]);
        setDisableChoosebutton(true);
        setData({
          ...savedData,
          Area: res[0].Area,
        });
        setLocationData(res[0]);
      } else {
        setDisableChoosebutton(false);
        setData({
          ...savedData,
        });
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    const savedFormData = sessionStorage.getItem("createProposalForm");
    if (savedFormData) {
      let savedData = JSON.parse(savedFormData);
      CheckCoordinateFunction(savedData.WorkName, savedData);
      sessionStorage.removeItem("createProposalForm");
    }

    FetchHeadInfo();
    FetchTalukaInfo();
    GetAllSchemesInfo();
  }, []);

  const navigatetoMap = (e) => {
    e.preventDefault();
    if (
      data.WorkName &&
      data.HeadCode &&
      data.District &&
      data.ConstituencyName &&
      data.GramPanchayat &&
      data.ProposalFileNumber &&
      data.JobId
    ) {
      // Save form data to sessionStorage
      sessionStorage.setItem("createProposalForm", JSON.stringify(data));
      nav(`/AdminDashboard/Mapfunction`);
    } else {
      alert("Fill Above Data !!!!");
    }
  };

  const CancelMapSubmission = async () => {
    const shouldclose = window.confirm("Are you Sure ?");
    if (shouldclose && data.WorkName && diableChoosebutton) {
      const payload = {
        WorkName: data.WorkName,
      };

      try {
        if (diableChoosebutton) {
          const res = await CreateMapCoordinateforProposal(
            "DeleteTechnicalCoordinateFromTable",
            payload,
          );
          console.log(res);
        }

        const savedFormData = sessionStorage.getItem("createProposalForm");

        if (savedFormData) {
          sessionStorage.removeItem("createProposalForm");
        }

        alert("Proposal Cancelled !!");
        window.location.reload();
      } catch (err) {
        console.log(err);
      }
    } else {
      alert("Proposal Cancelled !!");
      sessionStorage.removeItem("createProposalForm");
      window.location.reload();
    }
  };

  // useEffect(() => {
  //     GetVillages();
  // })
  const GetVillages = async () => {
    try {
      const res = await fetch(
        "https://api.data.gov.in/resource/c967fe8f-69c4-42df-8afc-8a2c98057437?api-key=579b464db66ec23bdd000001f257881c64214fe0771e79c1b568a4b6&format=json&limit=1000&filters%5BstateNameEnglish%5D=Maharashtra",
        {
          method: "GET",
          headers: {
            accept: "application/json",
          },
        },
      );
      console.log("Data i get:: ", res.json());
      // setVillage(res);
    } catch (err) {
      console.log(err);
    }
  };

  const GetGramPanchayat = async () => {
    try {
      let res = await GetGramPanchayatCodes(GPname, "Proposal");
      console.log(GPname);
      console.log("Data of grampanchayat:: ", res);
      // let GramPanchayat = res.filter((item) => item.Development_Block_Name === GPname);
      console.log("Data of grampanchayat:: ", res);
      setgramPanchayat(res);
    } catch (err) {
      console.log(err);
    }
  };

  const getEnglishNameOFTaluka = async () => {
    let res = await GetBudgetHeadInfo("null", "GetTalukas");
    let talukaNameEnglish = res.filter(
      (item) => item.ULBNameMarathi === data.Taluka,
    );
    console.log("Data of taluka:: ", talukaNameEnglish);
    if (talukaNameEnglish.length > 0) {
      setGPname(talukaNameEnglish[0].ULBName); // English name
    } else {
      console.warn("No matching Taluka found for Marathi name:", data.Taluka);
      setGPname("");
    }
  };

  useEffect(() => {
    getEnglishNameOFTaluka();
  }, [data.Taluka]);

  useEffect(() => {
    if (GPname) {
      GetGramPanchayat();
    }
  }, [GPname]);

  // const AddinTableOperation = (e) => {
  //     e.preventDefault();

  //     try {
  //         console.log("Fucntion Called : ");

  //         if (!data.isMultipleGp || !data.workClass || !data.workType || !data.WorkName || !data.RoadCategory || !data.RoadNumber || !data.proposedLength || data.GramPanchayat.length <= 0 || !data.ProposalAmount) {
  //             return alert("Please fill all fields before adding!");
  //         }

  //         if (parseFloat(data.ProposalAmount) <= 0) {
  //             alert("Enter Work Amount Greater than 0 !!");
  //             return;
  //         }

  //         let obj = {
  //             classOfWork: data.workClass,
  //             typeOfWork: data.workType,
  //             proposalworkname: data.WorkName,
  //             roadCategory: data.RoadCategory,
  //             roadNumber: data.RoadNumber,
  //             proposedLength: data.proposedLength,
  //             gramPanchayat: data.GramPanchayat,
  //             proposalworkamount: data.ProposalAmount,
  //             remark: data.Remark || "",
  //             isMultipleGpCode: data.isMultipleGp
  //         }

  //         let isDuplicate = tableData.some((entry) =>
  //             entry.classOfWork === obj.classOfWork &&
  //             entry.typeOfWork === obj.typeOfWork &&
  //             entry.proposalworkname === obj.proposalworkname &&
  //             entry.roadCategory === obj.roadCategory &&
  //             entry.roadNumber === obj.roadNumber &&
  //             entry.isMultipleGpCode === obj.isMultipleGpCode &&
  //             JSON.stringify(entry.gramPanchayat) === JSON.stringify(obj.gramPanchayat) &&
  //             Number(entry.proposalworkamount) === Number(obj.proposalworkamount) &&
  //             entry.remark === obj.remark &&
  //             entry.proposedLength === obj.proposedLength
  //         );

  //         if (isDuplicate) {
  //             alert("Duplicate entry !! This data already exists in the table.");
  //             return;
  //         }

  //         const updatedTable = [...tableData, obj];
  //         setTableData(updatedTable);

  //         const totalAmount = updatedTable.reduce(
  //             (sum, item) => sum + Number(item.proposalworkamount || 0),
  //             0
  //         );

  //         setData({
  //             ...data,
  //             workClass: "",
  //             WorkName: "",
  //             ProposalAmount: "",
  //             RoadCategory: "",
  //             RoadNumber: "",
  //             TotalProposalAmount: totalAmount,
  //             GramPanchayat: [],
  //             workType: "",
  //             Remark: "",
  //             proposedLength: ""
  //         });

  //         setShowPopup(false);
  //     }
  //     catch (err) {
  //         console.log("Error :: ", err);
  //     }
  // }
  const AddinTableOperation =async (e) => {
    e.preventDefault();
    try {
      if (
        !data.isMultipleGp ||
        !data.workClass ||
        !data.workType ||
        !data.WorkName ||
        !data.JobId ||
        !data.RoadCategory ||
        !data.RoadNumber ||
        !data.proposedLength ||
        data.GramPanchayat.length === 0 ||
        !data.ProposalAmount
      ) {
        alert("Please fill all fields before adding!");
        return;
      }

      if (parseFloat(data.ProposalAmount) <= 0) {
        alert("Enter Work Amount Greater than 0 !!");
        return;
      }

      const isDuplicateWorkName = tableData.some(
        (entry) =>
          entry.proposalworkname?.trim().toLowerCase() ===
          data.WorkName.trim().toLowerCase(),
      );

      if (isDuplicateWorkName) {
        alert("This Work Name already exists in the table!");
        return;
      }
if (await hasDuplicateWorkName(data.WorkName)) return;

      const obj = {
        classOfWork: data.workClass,
        typeOfWork: data.workType,
        proposalworkname: data.WorkName,
        JobId: data.JobId,
        roadCategory: data.RoadCategory,
        roadNumber: data.RoadNumber,
        proposedLength: data.proposedLength,
        gramPanchayat: data.GramPanchayat,
        proposalworkamount: data.ProposalAmount,
        remark: data.Remark || "",
        isMultipleGpCode: data.isMultipleGp,
      };

      const isDuplicate = tableData.some(
        (entry) =>
          entry.classOfWork === obj.classOfWork &&
          entry.typeOfWork === obj.typeOfWork &&
          entry.proposalworkname === obj.proposalworkname &&
          entry.JobId === obj.JobId &&
          entry.roadCategory === obj.roadCategory &&
          entry.roadNumber === obj.roadNumber &&
          entry.isMultipleGpCode === obj.isMultipleGpCode &&
          JSON.stringify(entry.gramPanchayat) ===
            JSON.stringify(obj.gramPanchayat) &&
          Number(entry.proposalworkamount) === Number(obj.proposalworkamount) &&
          entry.remark === obj.remark &&
          entry.proposedLength === obj.proposedLength,
      );

      if (isDuplicate) {
        alert("Duplicate entry !! This data already exists in the table.");
        return;
      }

      const updatedTable = [...tableData, obj];
      setTableData(updatedTable);

      const totalAmount = updatedTable.reduce(
        (sum, item) => sum + Number(item.proposalworkamount || 0),
        0,
      );

      setData((prev) => ({
        ...prev,
        workClass: "",
        workType: "",
        WorkName: "",
        JobId: "",
        RoadCategory: "",
        RoadNumber: "",
        proposedLength: "",
        ProposalAmount: "",
        GramPanchayat: [],
        Remark: "",
        TotalProposalAmount: totalAmount,
      }));

      setShowPopup(false);
    } catch (err) {
      console.log("Error :: ", err);
    }
  };
  const handleEdit = (e, index) => {
    e.preventDefault();
    const item = tableData[index];
    console.log("table i selected :: ", item);
    setEditIndex(item);
    setIndexofEditing(index);
  };

  const handleDelete = (e, index) => {
    e.preventDefault();

    const updated = tableData.filter((_, i) => i !== index);

    // 🔥 Recalculate total after delete
    const totalAmount = updated.reduce(
      (sum, item) => sum + Number(item.proposalworkamount || 0),
      0,
    );

    setTableData(updated);

    setData((prev) => ({
      ...prev,
      TotalProposalAmount: totalAmount,
    }));
  };

  // const handelchangeTablre = (e) => {
  //     e.preventDefault();
  //     const updatedData = [...tableData];
  //     updatedData[Indexofediting] = editIndex;
  //     setTableData(updatedData);
  //     console.log("Editted Index :: ", editIndex);
  //     setEditIndex(null);
  //     setIndexofEditing(null);
  // };

  const handelchangeTablre = (e) => {
    e.preventDefault();
    if (
      !editIndex?.proposalworkname?.trim() ||
      !editIndex?.proposalworkamount?.toString().trim()
    ) {
      alert("Please fill value for all fields");
      return;
    }

    if (Indexofediting === null || editIndex === null) return;

    const updatedData = [...tableData];
    updatedData[Indexofediting] = { ...editIndex };
    setTableData(updatedData);
    const totalAmount = updatedData.reduce(
      (sum, item) => sum + Number(item.proposalworkamount || 0),
      0,
    );
    setData({
      ...data,
      TotalProposalAmount: totalAmount,
    });
    console.log("Edited Row:", editIndex);
    setEditIndex(null);
    setIndexofEditing(null);
  };

  const GetTypesOfWork = async () => {
    console.log(data.HeadCode);
    try {
      let res = await TypesOfWork(data.HeadCode);
      setLoading(true);
      setWorkId(res);
      console.log("Type Of Work :: ", res);
      console.log("Work Class :: ", data.workClass);

      if (
        data.HeadCode ==
        "3054-2419(Roads and bridge repair maintenance program)"
      ) {
        let workNames = res.filter((item) => item.Work_Type === data.workClass);
        console.log("Work Names :: ", workNames);
        setWork(workNames);
      } else {
        setWork(res);
      }
      setLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    GetTypesOfWork();
  }, [data.HeadCode, data.workClass, data.workType]);

  useEffect(() => {
    setData((prev) => ({ ...prev, GramPanchayat: [] }));
    setShowPopup(false);
  }, [data.isMultipleGp]);

  const getAdministrativeYears = () => {
    const startYear = 2025;
    const currentYear = new Date().getFullYear();

    let years = [];

    for (let year = startYear; year <= currentYear; year++) {
      years.push(`${year}-${year + 1}`);
    }

    return years;
  };
  return (
    <>
      <div style={{ height: "91vh", overflowY: "auto" }}>
        <div
          className="col-12"
          style={{ backgroundColor: "#EFF3F8", padding: "2rem 0px 5px 0px" }}
        >
          <div className="col-12 m-auto my-5 budgetContainer">
            <div className="m-auto budgetElement">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  paddingBottom: "10px",
                }}
              >
                <div>
                  <h5 className=" bg-light">
                    <img src={ProposalCreation32} />
                    {t("Proposal Creation")}
                  </h5>
                </div>
              </div>
              <p
                className="py-2 ps-1 fw-bold text-danger"
                style={{ backgroundColor: "#FBE7E7" }}
              >
                {t("Note : Fields marked with * are mandatory")}
              </p>
              {loading && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: "rgba(255, 255, 255, 0.7)",
                    backdropFilter: "blur(4px)",
                    zIndex: 9999,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      border: "6px solid #f3f3f3",
                      borderTop: "6px solid #007bff",
                      borderRadius: "50%",
                      width: "60px",
                      height: "60px",
                      animation: "spin 1s linear infinite",
                    }}
                  />
                  <style>
                    {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
                  </style>
                </div>
              )}

              <div className="">
                <form action="">
                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-5">
                        <label>
                          {t("Head Code")}
                          <span className="text-danger fw-bold">*</span>
                        </label>
                      </div>
                      <div className="col-7">
                        <input
                          type="text"
                          name="HeadCode"
                          value={data.HeadCode}
                          className="py-2"
                          onChange={HandleChangeData}
                          disabled
                        ></input>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-5">
                        <label>
                          {t("Proposal Year")}
                          <span className="text-danger fw-bold">*</span>
                        </label>
                      </div>
                      <div className="col-7">
                        {/* <input type="text" name="ProposalYear" value={data.ProposalYear} className='py-2'  disabled></input> */}
                        <select
                          name="ProposalYear"
                          value={data.ProposalYear}
                          className="py-2"
                          onChange={HandleChangeData}
                          required
                        >
                          <option value="">{t("Select Proposal Year")}</option>
                          {getAdministrativeYears().map((year, index) => (
                            <option key={index} value={year}>
                              {year}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-12 elements">
                                        <div className="row">
                                            <div className="col-5">
                                                <label>Scheme Name</label>
                                            </div>
                                            <div className="col-7">
                                                <select name="SchemeName" value={data.SchemeName} className='py-2' onChange={HandleChangeData} required>
                                                    <option value="">Select Scheme</option>
                                                    {
                                                        Scheme &&
                                                        Scheme.map((e, index) => (
                                                            <option value={e.SchemeName} key={index}>{e.SchemeName}</option>
                                                        ))
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                    </div> */}

                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-5 my-auto">
                        <label className="my-auto">
                          {t("Taluka")}{" "}
                          <span className="text-danger fw-bold">*</span>
                        </label>
                      </div>
                      <div className="col-7">
                        {/* <select name="Taluka" value={data.Taluka} className='py-2' onChange={HandleChangeData}>
                                                <option value="">Select Taluka</option>
                                                {
                                                    Taluka &&
                                                    [...new Set(Taluka.map(val => val.ULBName))].map((ULBName, index) => (
                                                        <option value={ULBName} key={index}>{ULBName}</option>
                                                    ))
                                                }
                                                <option value={"Wakad"} >{"Wakad"}</option>
                                            </select> */}
                        <select
                          name="Taluka"
                          value={data.TalukaSelection}
                          className="py-2"
                          onChange={HandleChangeData}
                          required
                        >
                          <option value="">{t("Select Taluka")}</option>
                          {Taluka &&
                            [
                              ...new Set(
                                Taluka.map((val) => val.ULBNameMarathi),
                              ),
                            ].map((ULBNameMarathi, index) => {
                              const district =
                                Taluka.find(
                                  (t) => t.ULBNameMarathi === ULBNameMarathi,
                                )?.District_Marathi || "";
                              return (
                                <option
                                  key={index}
                                  value={`${ULBNameMarathi}|${district}`}
                                >
                                  {ULBNameMarathi}
                                </option>
                              );
                            })}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-5">
                        <label>
                          {t("Constituency Name")}
                          <span className="text-danger fw-bold">*</span>
                        </label>
                      </div>
                      <div className="col-7">
                        <input
                          type="text"
                          placeholder={t("Enter Constituency Name")}
                          className="form-control py-2"
                          name="ConstituencyName"
                          maxLength={100}
                          value={data.ConstituencyName}
                          onChange={HandleChangeData}
                          // onChange={(e) => {
                          //     const value = e.target.value.replace(/[^a-zA-Z0-9\s]/g, "");
                          //     HandleChangeData({ target: { name: e.target.name, value } });
                          // }}
                          onBlur={(e) => {
                            const value = e.target.value.trim();

                            // Check if at least ONE valid character exists
                            const hasValidChar =
                              /[a-zA-Z0-9\u0900-\u097F]/.test(value);
                            if (value && !hasValidChar) {
                              setError("Enter at least one valid character");
                              alert("Enter at least one valid character");
                              setTimeout(() => e.target.focus(), 0);
                            } else {
                              setError("");
                            }
                          }}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  {/* <div className="col-12 elements">
                                        <div className="row">
                                            <div className="col-5"><label>Class Of Work<span className='text-danger fw-bold'>*</span></label></div>
                                            <div className="col-7">
                                                <select name="workClass" id="" value={data.workClass} onChange={HandleChangeData}>
                                                    <option value="" >Choose Class Of Work</option>
                                                    {WorkId && [...new Set(WorkId.map(item => item.Work_Type))].map((val, index) => (
                                                        <option key={index} value={val}>{val || "N/A"}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    </div> */}

                  {/* <div className="col-12 elements">
                                        <div className="row">
                                            <div className="col-5"><label>Type of Work <span className='text-danger fw-bold'>*</span></label></div>
                                            <div className="col-7">
                                                <select name="workType" id="" value={data.workType} onChange={HandleChangeData}>
                                                    <option value="" >Choose Type of Work</option>
                                                    {getWork && getWork.map((val, index) => {
                                                        return (
                                                            <option key={index} value={val.Work_name}>{val.Work_name}</option>
                                                        )
                                                    })}
                                                </select>
                                            </div>
                                        </div>
                                    </div> */}

                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-5">
                        <label>
                          {t("This involves multiple Gram Panchayat?")}
                          <span className="text-danger fw-bold">*</span>
                        </label>
                      </div>
                      <div
                        className="col-7"
                        style={{ display: "flex", gap: "15px" }}
                      >
                        <div>
                          <label>
                            <input
                              type="radio"
                              name="isMultipleGp"
                              value="Yes"
                              onChange={HandleChangeData}
                              checked={data.isMultipleGp === "Yes"}
                            />
                          </label>
                          <label>{t("Yes")}</label>
                        </div>
                        <div>
                          <label>
                            <input
                              type="radio"
                              name="isMultipleGp"
                              value="No"
                              onChange={HandleChangeData}
                              checked={data.isMultipleGp === "No"}
                            />
                          </label>
                          <label>{t("No")}</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <div className="col-12 elements">
                                        <div className="row">
                                            <div className="col-5">
                                                <label>Gram Panchayat</label>
                                            </div>
                                            <div className="col-7">
                                                <select
                                                    name="GramPanchayat"
                                                    value={data.GramPanchayat}
                                                    className="py-2"
                                                    onChange={HandleChangeData}
                                                >
                                                    <option value="">Select Gram Panchayat</option>
                                                    {[...new Set(gramPanchayat.map((gp) => gp.Village_Panchayat_Name))].map(
                                                        (name, index) => (
                                                            <option value={name} key={index}>
                                                                {name}
                                                            </option>
                                                        )
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                    </div> */}

                  {/* <div className="col-12 elements">
                                        <div className="row">
                                            <div className="col-5">
                                                <label>Work Name</label>
                                            </div>
                                            <div className="col-7">
                                                <input type="text" placeholder='Enter Work Name' className='form-control py-2' name='WorkName'
                                                    maxLength={100}
                                                    value={data.WorkName}
                                                    onChange={HandleChangeData} required />
                                            </div>
                                        </div>
                                    </div> */}

                  {/* <div className="col-12 elements">
                                        <div className="row">
                                            <div className="col-5">
                                                <label>Proposal Work Amount</label>
                                            </div>
                                            <div className="col-7">
                                                <input type="number"
                                                    placeholder='Enter Proposal Work Amount'
                                                    className='form-control py-2'
                                                    name='ProposalAmount'
                                                    min="0"
                                                    onKeyDown={(e) => {
                                                        if (
                                                            ["e", "E", "+", "-"].includes(e.key) ||
                                                            (e.key === "." && e.target.value.includes(".")) // prevent multiple dots
                                                        ) {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                    value={data.ProposalAmount < 0 ? 0 : data.ProposalAmount}
                                                    onChange={HandleChangeData} required="true" />
                                            </div>

                                        </div>
                                    </div> */}

                  {/* <div className="col-12 elements">
                                        <div className="row">
                                            <div className="col-5">
                                                <label>Road Category</label>
                                            </div>
                                            <div className="col-7">
                                                <input type="text" placeholder='Enter Road Category' className='form-control py-2' name='RoadCategory'
                                                    value={data.RoadCategory}
                                                    onChange={HandleChangeData} required />
                                            </div>
                                        </div>
                                    </div> */}

                  {/* <div className="col-12 elements">
                                        <div className="row">
                                            <div className="col-5">
                                                <label>Road Number</label>
                                            </div>
                                            <div className="col-7">
                                                <input type="text" placeholder='Enter Constituency Name' className='form-control py-2' name='RoadNumber'
                                                    value={data.RoadNumber}
                                                    onChange={HandleChangeData} required />
                                            </div>
                                        </div>
                                    </div> */}

                  {/* <div className="col-12 elements">
                                        <div className="row">
                                            <div className="col-5">
                                                <label>Remark</label>
                                            </div>
                                            <div className="col-7">
                                                <input type="text" placeholder='Enter Remark' className='form-control py-2' name='Remark'
                                                    value={data.Remark}
                                                    onChange={HandleChangeData} required />
                                            </div>
                                        </div>
                                    </div> */}

                  <div className="col-12 pb-5 mt-3">
                    <div
                      className="col-12 "
                      style={{
                        display: "flex",
                        overflowX: "auto",

                        width: "100%",
                      }}
                    >
                      <table
                        className="m-0 p-0"
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                        }}
                      >
                        <thead>
                          <tr
                            style={{
                              color: "white",
                              border: "none",
                              height: "3rem",
                              fontSize: "14px",
                            }}
                          >
                            <th
                              style={{ padding: "7px 10px", minWidth: "200px" }}
                            >
                              {t("Class Of Work")}
                              <span className="text-danger fw-bold">*</span>
                            </th>
                            <th
                              style={{ padding: "7px 10px", minWidth: "190px" }}
                            >
                              {t("Type of Work")}
                              <span className="text-danger fw-bold">*</span>
                            </th>
                            <th
                              style={{ padding: "7px 10px", minWidth: "240px" }}
                            >
                              {t("Work Name")}
                              <span className="text-danger fw-bold">*</span>
                            </th>
                            <th
                              style={{ padding: "7px 10px", minWidth: "200px" }}
                            >
                              {t("Job ID")}
                              <span className="text-danger fw-bold">*</span>
                            </th>
                            <th
                              style={{ padding: "7px 10px", minWidth: "200px" }}
                            >
                              {t("Road Category")}
                              <span className="text-danger fw-bold">*</span>
                            </th>
                            <th
                              style={{ padding: "7px 10px", minWidth: "180px" }}
                            >
                              {t("Road Number")}
                              <span className="text-danger fw-bold">*</span>
                            </th>
                            <th
                              style={{ padding: "7px 10px", minWidth: "180px" }}
                            >
                              {t("Proposed Length (in Km)")}
                              <span className="text-danger fw-bold">*</span>
                            </th>
                            <th
                              style={{ padding: "7px 10px", minWidth: "180px" }}
                            >
                              {t("Gram Panchayat")}
                              <span className="text-danger fw-bold">*</span>
                            </th>
                            <th
                              style={{ padding: "7px 10px", minWidth: "220px" }}
                            >
                              {t("Work Amount")}
                              <span className="text-danger fw-bold">*</span>
                            </th>
                            <th
                              style={{ padding: "7px 10px", minWidth: "240px" }}
                            >
                              {t("Remark")}
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr>
                            <td>
                              <select
                                name="workClass"
                                id=""
                                value={data.workClass}
                                onChange={HandleChangeData}
                                className="form-select form-select-sm custom-select"
                                required
                              >
                                <option value="" disabled>
                                  {t("Choose Class Of Work")}
                                </option>
                                {WorkId &&
                                  [
                                    ...new Set(
                                      WorkId.map((item) => item.Work_Type),
                                    ),
                                  ]
                                    .sort()
                                    .map((val, index) => (
                                      <option key={index} value={val}>
                                        {val || "N/A"}
                                      </option>
                                    ))}
                              </select>
                            </td>

                            <td>
                              <select
                                name="workType"
                                id=""
                                value={data.workType}
                                onChange={HandleChangeData}
                                className="form-select form-select-sm custom-select"
                                required
                              >
                                <option value="" disabled>
                                  {t("Choose Type of Work")}
                                </option>
                                {getWork &&
                                  getWork.map((val, index) => {
                                    return (
                                      <option key={index} value={val.Work_name}>
                                        {val.Work_name}
                                      </option>
                                    );
                                  })}
                              </select>
                            </td>
                            <td>
                              <input
                                type="text"
                                name="WorkName"
                                placeholder={t("Enter Work Name")}
                                className="form-control form-control-sm custom-input"
                                value={data.WorkName}
                                maxLength={200}
                                onChange={(e) => {
                                  let value = e.target.value
                                    .replace(
                                      /[^0-9\u0900-\u097F\s!@#$%^&*()_+=\-{}[\]:;"'<>,.?/\\|]/g,
                                      "",
                                    )
                                    .replace(/^\s+/, "");
                                  if (value.length > 500) return;

                                  HandleChangeData({
                                    target: { name: "WorkName", value },
                                  });
                                }}
                                //   onChange={HandleChangeData}
                                onBlur={(e) => {
                                  const value = e.target.value.trim();

                                  // Check if at least ONE valid character exists
                                  const hasValidChar =
                                    /[a-zA-Z0-9\u0900-\u097F]/.test(value);
                                  if (value && !hasValidChar) {
                                    setError(
                                      "Enter at least one valid character",
                                    );
                                    alert("Enter at least one valid character");
                                    setTimeout(() => e.target.focus(), 0);
                                  } else {
                                    setError("");
                                  }
                                }}
                                required
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                name="JobId"
                                pattern="[0-9]*"
                                placeholder={t("Enter Job Id here")}
                                className="form-control form-control-sm custom-input"
                                value={data.JobId}
                                maxLength={12}
                                onChange={(e) => {
                                  let value = e.target.value.replace(/\D/g, "");
                                  HandleChangeData({
                                    target: { name: "JobId", value },
                                  });
                                }}
                                required
                              />
                            </td>
                            {/* <td>
                                                            <input
                                                                type="text"
                                                                name="RoadCategory"
                                                                placeholder="Enter Category"
                                                                className="form-control"
                                                                value={data.RoadCategory}
                                                                onChange={HandleChangeData}
                                                                required
                                                            />
                                                        </td>

                                                        <td>
                                                            <input
                                                                type="text"
                                                                name="RoadNumber"
                                                                placeholder="Enter Road No."
                                                                className="form-control"
                                                                value={data.RoadNumber}
                                                                onChange={HandleChangeData}
                                                                required
                                                            />
                                                        </td> */}
                            <td>
                              <select
                                name="RoadCategory"
                                id=""
                                value={data.RoadCategory}
                                onChange={HandleChangeData}
                                className="form-select form-select-sm custom-select"
                                required
                              >
                                <option value="" disabled>
                                  {t("Choose Road Category")}
                                </option>
                                <option>{t("Village Road")}</option>
                                <option>{t("Other District Road")}</option>
                              </select>
                            </td>
                            <td>
                              {" "}
                              <input
                                type="text"
                                name="RoadNumber"
                                placeholder={t("Enter Road No")}
                                className="form-control form-control-sm custom-input"
                                value={data.RoadNumber}
                                onChange={HandleChangeData}
                                onBlur={(e) => {
                                  const value = e.target.value.trim();

                                  // Check if at least ONE valid character exists
                                  const hasValidChar =
                                    /[a-zA-Z0-9\u0900-\u097F]/.test(value);
                                  if (value && !hasValidChar) {
                                    setError(
                                      "Enter at least one valid character",
                                    );
                                    alert("Enter at least one valid character");
                                    setTimeout(() => e.target.focus(), 0);
                                  } else {
                                    setError("");
                                  }
                                }}
                                required
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                name="proposedLength"
                                placeholder={t("Enter Proposed Length")}
                                className="form-control form-control-sm custom-input"
                                value={data.proposedLength}
                                // onChange={HandleChangeData}
                                onChange={(e) => {
                                  const value = e.target.value.replace(
                                    /[^a-zA-Z0-9.\s!@#$%^&*()_+\-=\[\]{};:'",.<>?/\\|]/g,
                                    "",
                                  );
                                  // const value = e.target.value.replace(/[^a-zA-Z0-9.\s]/g, "");
                                  HandleChangeData({
                                    target: { name: e.target.name, value },
                                  });
                                }}
                                onBlur={(e) => {
                                  const value = e.target.value.trim();

                                  // Check if at least ONE valid character exists
                                  const hasValidChar =
                                    /[a-zA-Z0-9\u0900-\u097F]/.test(value);
                                  if (value && !hasValidChar) {
                                    setError(
                                      "Enter at least one valid character",
                                    );
                                    alert("Enter at least one valid character");
                                    setTimeout(() => e.target.focus(), 0);
                                  } else {
                                    setError("");
                                  }
                                }}
                                required
                              />
                            </td>

                            {/* <td>
                                                            <select
                                                                name="GramPanchayat"
                                                                value={data.GramPanchayat}
                                                                className="form-select"
                                                                onChange={HandleChangeData}
                                                            >
                                                                <option value="">Select</option>
                                                                {[...new Set(gramPanchayat.map((gp) => gp.Village_Panchayat_Name))].map(
                                                                    (name, index) => (
                                                                        <option value={name} key={index}>
                                                                            {name}
                                                                        </option>
                                                                    )
                                                                )}
                                                            </select>
                                                        </td> */}

                            {/* <td>
                                                            <div
                                                                style={{
                                                                    border: "1px solid #ccc",
                                                                    borderRadius: "5px",
                                                                    padding: "5px",
                                                                    maxHeight: "120px",
                                                                    overflowY: "auto",
                                                                    width : "100%"
                                                                }}
                                                            >
                                                                {[...new Set(gramPanchayat.map(gp => gp.Village_Panchayat_Name))].map((name, index) => (
                                                                    <div key={index} style={{ marginBottom: "4px" }}>
                                                                        <input
                                                                            type="checkbox"
                                                                            id={`gp-${index}`}
                                                                            value={name}
                                                                            checked={data.GramPanchayat.includes(name)}
                                                                            onChange={(e) => {
                                                                                if (e.target.checked) {
                                                                                    setData(prev => ({ ...prev, GramPanchayat: [...prev.GramPanchayat, name] }));
                                                                                } else {
                                                                                    // remove from array
                                                                                    setData(prev => ({ ...prev, GramPanchayat: prev.GramPanchayat.filter(gp => gp !== name) }));
                                                                                }
                                                                            }}
                                                                        />
                                                                        <label htmlFor={`gp-${index}`} style={{ marginLeft: "5px" }}>{name}</label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </td> */}

                            <td>
                              <div className="col-12">
                                {showPopup == false &&
                                  data.GramPanchayat.length <= 0 && (
                                    <button
                                      type="button"
                                      onClick={() => {
                                        if (
                                          !data.Taluka ||
                                          !data.isMultipleGp ||
                                          !data.HeadCode
                                        ) {
                                          alert(
                                            "Plz Fill Above Missing Data !!",
                                          );
                                        } else {
                                          setShowPopup(true);
                                        }
                                      }}
                                      className="btn btn-success"
                                    >
                                      {t("Select Gram Panchayat")}
                                    </button>
                                  )}

                                {data.GramPanchayat.length > 0 && (
                                  <div
                                    className="col-12"
                                    style={{
                                      overflowX: "hidden",
                                      overflowWrap: "break-word",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {data.GramPanchayat.join(", ")}
                                  </div>
                                )}
                              </div>
                            </td>

                            <td>
                              <input
                                type="number"
                                name="ProposalAmount"
                                placeholder={t("Enter Work Amount")}
                                className="form-control form-control-sm custom-input"
                                min="1"
                                max="999999999.99"
                                step="0.01"
                                value={data.ProposalAmount}
                                onKeyDown={(e) => {
                                  if (["e", "E", "+", "-"].includes(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={(e) => {
                                  let value = e.target.value;
                                  // Allow empty while typing
                                  if (value === "") {
                                    HandleChangeData(e);
                                    return;
                                  }
                                  // Convert to number
                                  let num = Number(value);
                                  // Range validation
                                  if (num < 1) return;
                                  if (num > 999999999.99) return;
                                  // Decimal places limit (2)
                                  if (
                                    value.includes(".") &&
                                    value.split(".")[1].length > 2
                                  )
                                    return;
                                  if (!/^\d*(\.\d{0,2})?$/.test(value)) return;
                                  HandleChangeData(e);
                                }}
                                required
                              />
                            </td>

                            <td>
                              <input
                                type="text"
                                name="Remark"
                                placeholder={t("Enter Remark")}
                                className="form-control form-control-sm custom-input"
                                value={data.Remark}
                                onChange={HandleChangeData}
                                onBlur={(e) => {
                                  const value = e.target.value.trim();

                                  // Check if at least ONE valid character exists
                                  const hasValidChar =
                                    /[a-zA-Z0-9\u0900-\u097F]/.test(value);
                                  if (value && !hasValidChar) {
                                    setError(
                                      "Enter at least one valid character",
                                    );
                                    alert("Enter at least one valid character");
                                    setTimeout(() => e.target.focus(), 0);
                                  } else {
                                    setError("");
                                  }
                                }}
                                required
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {showPopup && (
                    <div
                      style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: "rgba(0, 0, 0, 0.21)",
                        backdropFilter: "blur(4px)",
                        zIndex: 999,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div
                        className="m-auto"
                        style={{
                          background: "white",
                          height: "400px",
                          width: "450px",
                          overflowY: "auto",
                          overflowX: "hidden",
                          padding: "20px",
                        }}
                      >
                        <div style={{ position: "relative" }}>
                          <button
                            type="button"
                            // onClick={() => setShowPopup(false)}
                            onClick={() => {
                              if (data.isMultipleGp == "Yes") {
                                if (data.GramPanchayat.length < 2) {
                                  alert(
                                    "Minimum of 2 Gram Panchayats should be Selected !",
                                  );
                                  return;
                                }
                              }
                              setShowPopup(false);
                            }}
                            style={{
                              padding: "5px 10px",
                              fontSize: "13px",
                              borderRadius: "3px",
                              border: "none",
                              backgroundColor: "#2ff01aff",
                              color: "#fff",
                              cursor: "pointer",
                              fontWeight: "500",
                              width: "8rem",
                            }}
                          >
                            {t("Save")}
                          </button>
                          <button
                            type="button"
                            // onClick={() => setShowPopup(false)}
                            onClick={() => {
                              setData({
                                ...data,
                                GramPanchayat: [],
                              });
                              setShowPopup(false);
                            }}
                            style={{
                              padding: "5px 10px",
                              fontSize: "18px",
                              borderRadius: "3px",
                              border: "none",
                              backgroundColor: "#b60101",
                              color: "#fff",
                              cursor: "pointer",
                              fontWeight: "600",
                              lineHeight: "1",
                              float: "right",
                            }}
                            title="Close"
                          >
                            &times;
                          </button>
                        </div>

                        <div className="col-12">
                          <div
                            style={{ textAlign: "center", marginTop: "20px" }}
                          ></div>
                          {[
                            ...new Set(
                              gramPanchayat.map(
                                (gp) => gp.Village_Panchayat_Name,
                              ),
                            ),
                          ].map((name, index) => (
                            <div
                              className="col-12"
                              key={index}
                              style={{ marginBottom: "5px", fontSize: "12px" }}
                            >
                              <div className="row">
                                <div className="col-2 m-auto">
                                  <input
                                    type="checkbox"
                                    id={`gp-${index}`}
                                    value={name}
                                    checked={data.GramPanchayat.includes(name)}
                                    style={{
                                      margin: "auto",
                                    }}
                                    onChange={(e) => {
                                      if (data.isMultipleGp == "No") {
                                        setData((prev) => ({
                                          ...prev,
                                          GramPanchayat: [name],
                                        }));
                                        setShowPopup(false);
                                      } else {
                                        if (e.target.checked) {
                                          if (data.GramPanchayat.length >= 5) {
                                            alert(
                                              "You can select a maximum of 5 Gram Panchayats only.",
                                            );
                                            setShowPopup(false);
                                            return;
                                          }
                                          setData((prev) => ({
                                            ...prev,
                                            GramPanchayat: [
                                              ...prev.GramPanchayat,
                                              name,
                                            ],
                                          }));
                                        } else {
                                          setData((prev) => ({
                                            ...prev,
                                            GramPanchayat:
                                              prev.GramPanchayat.filter(
                                                (gp) => gp !== name,
                                              ),
                                          }));
                                        }
                                      }
                                    }}
                                  />
                                </div>

                                <div className="col-10 m-auto">
                                  <label
                                    className="col-12 my-auto"
                                    htmlFor={`gp-${index}`}
                                  >
                                    {name}
                                  </label>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="col-12 text-center mb-4 mt-1">
                    <div className="col-10 m-auto">
                      <button
                        type="button"
                        className="btn btn-success px-4 py-1"
                        onClick={AddinTableOperation}
                      >
                        {t("ADD")}
                      </button>
                    </div>
                  </div>

                  {tableData && tableData.length > 0 && (
                    <div className="col-12 my-5">
                      <div className="row">
                        <div className="col-12 tableContainer100">
                          <div style={{ overflowX: "auto", maxWidth: "100%" }}>
                            <table
                              className="m-0 p-0"
                              style={{
                                width: "100%",
                                borderCollapse: "collapse",
                                whiteSpace: "nowrap",
                              }}
                            >
                              <thead
                                style={{
                                  backgroundColor: "#f0f3f8", // 🔹 light gray-blue header
                                  color: "#333",
                                  height: "3rem",
                                  fontSize: "14px",
                                }}
                              >
                                <tr>
                                  <th
                                    style={{
                                      padding: "7px 10px",
                                      minWidth: "40px",
                                    }}
                                  >
                                    {t("Sr.No")}
                                  </th>
                                  <th
                                    style={{
                                      padding: "7px 10px",
                                      minWidth: "170px",
                                    }}
                                  >
                                    {t("Class Of Work")}
                                  </th>
                                  <th
                                    style={{
                                      padding: "7px 10px",
                                      minWidth: "190px",
                                    }}
                                  >
                                    {t("Type of Work")}
                                  </th>
                                  <th
                                    style={{
                                      padding: "7px 10px",
                                      minWidth: "240px",
                                    }}
                                  >
                                    {t("Work Name")}
                                  </th>
                                  <th
                                    style={{
                                      padding: "7px 10px",
                                      minWidth: "200px",
                                    }}
                                  >
                                    {t("Job ID")}
                                  </th>
                                  <th
                                    style={{
                                      padding: "7px 10px",
                                      minWidth: "170px",
                                    }}
                                  >
                                    {t("Road Category")}
                                  </th>
                                  <th
                                    style={{
                                      padding: "7px 10px",
                                      minWidth: "180px",
                                    }}
                                  >
                                    {t("Road Number")}
                                  </th>
                                  <th
                                    style={{
                                      padding: "7px 10px",
                                      minWidth: "180px",
                                    }}
                                  >
                                    {t("Proposed Length")}
                                  </th>
                                  <th
                                    style={{
                                      padding: "7px 10px",
                                      minWidth: "180px",
                                    }}
                                  >
                                    {t("Gram Panchayat")}
                                  </th>
                                  <th
                                    style={{
                                      padding: "7px 10px",
                                      minWidth: "170px",
                                    }}
                                  >
                                    {t("Work Amount")}
                                  </th>
                                  <th
                                    style={{
                                      padding: "7px 10px",
                                      minWidth: "240px",
                                    }}
                                  >
                                    {t("Remark")}
                                  </th>
                                  <th
                                    style={{
                                      padding: "7px 10px",
                                      minWidth: "180px",
                                    }}
                                  >
                                    {t("Actions")}
                                  </th>
                                </tr>
                              </thead>

                              <tbody>
                                {tableData.map((val, index) => {
                                  const bgColor =
                                    index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                  return (
                                    <tr
                                      key={index}
                                      style={{
                                        backgroundColor: bgColor,
                                        height: "2.5rem",
                                        borderBottom: "1px solid #ddd",
                                      }}
                                    >
                                      <td style={{ padding: "6px 10px" }}>
                                        {index + 1}
                                      </td>
                                      <td style={{ padding: "6px 10px" }}>
                                        {val.classOfWork}
                                      </td>
                                      <td style={{ padding: "6px 10px" }}>
                                        {val.typeOfWork}
                                      </td>
                                      <td style={{ padding: "6px 10px" }}>
                                        {val.proposalworkname}
                                      </td>
                                      <td style={{ padding: "6px 10px" }}>
                                        {val.JobId}
                                      </td>
                                      <td style={{ padding: "6px 10px" }}>
                                        {val.roadCategory}
                                      </td>
                                      <td style={{ padding: "6px 10px" }}>
                                        {val.roadNumber}
                                      </td>
                                      <td style={{ padding: "6px 10px" }}>
                                        {val.proposedLength}
                                      </td>
                                      <td style={{ padding: "6px 10px" }}>
                                        <div
                                          className="col-12"
                                          style={{
                                            overflowX: "hidden",
                                            overflowWrap: "break-word",
                                            whiteSpace: "normal",
                                          }}
                                        >
                                          {val.gramPanchayat.join(", ")}
                                        </div>
                                      </td>
                                      <td style={{ padding: "6px 10px" }}>
                                        {val.proposalworkamount}
                                      </td>
                                      <td style={{ padding: "6px 10px" }}>
                                        {val.remark}
                                      </td>
                                      <td style={{ padding: "6px 10px" }}>
                                        <button
                                          className="btn btn-sm btn-primary mx-1"
                                          onClick={(e) => handleEdit(e, index)}
                                        >
                                          {t("Edit")}
                                        </button>
                                        <button
                                          className="btn btn-sm btn-danger mx-1"
                                          onClick={(e) =>
                                            handleDelete(e, index)
                                          }
                                        >
                                          {t("Delete")}
                                        </button>
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {editIndex && (
                    <div
                      style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: "rgba(0, 0, 0, 0.4)",
                        backdropFilter: "blur(6px)",
                        zIndex: 100,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        animation: "fadeIn 0.3s ease-in-out",
                      }}
                    >
                      <div className="col-6 shadow-lg rounded-4 p-4 bg-white border-0 m-auto">
                        <div className="col-12 m-auto rounded p-4 border border-dark">
                          <form action="">
                            <div className="row">
                              <div className="col-12 my-2">
                                <div className="row">
                                  <div className="col-6">
                                    <label>{t("Proposal Work Name ")}</label>
                                  </div>

                                  <div className="col-6">
                                    <input
                                      type="text"
                                      value={editIndex.proposalworkname}
                                      onChange={(e) => {
                                        let value = e.target.value;
                                        if (
                                          value.length === 1 &&
                                          value[0] === " "
                                        )
                                          return;
                                        if (value.length > 500) return;
                                        setEditIndex((prev) => ({
                                          ...prev,
                                          proposalworkname: value,
                                        }));
                                      }}
                                      required
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="col-12 my-2">
                                <div className="row">
                                  <div className="col-6">
                                    <label>{t("Proposal Work Amount")}</label>
                                  </div>
                                  <div className="col-6">
                                    {/* <input type="text" value={editIndex.proposalworkamount} name="amount" min="1" max="999999999.99" step="0.01"
                                                                            onKeyDown={(e) => {
                                                                                if (["e", "E", "+", "-"].includes(e.key)) { e.preventDefault();}
                                                                            }}
                                                                            onChange={(e) => {
                                                                                let value = e.target.value;
                                                                                if (value === "") { HandleChangeData(e);return;}
                                                                                let num = Number(value);
                                                                                if (num < 1) return;
                                                                                if (num > 999999999.99) return;
                                                                                if (value.includes(".") && value.split(".")[1].length > 2) return;
                                                                                setEditIndex({
                                                                                    ...editIndex,
                                                                                    proposalworkamount: e.target.value,
                                                                                })
                                                                            }}/> */}
                                    <input
                                      type="number"
                                      value={editIndex.proposalworkamount}
                                      name="amount"
                                      min={1}
                                      step="1"
                                      onKeyDown={(e) => {
                                        if (
                                          ["e", "E", "+", "-"].includes(e.key)
                                        ) {
                                          e.preventDefault();
                                        }
                                      }}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        if (value === "") {
                                          setEditIndex({
                                            ...editIndex,
                                            proposalworkamount: "",
                                          });
                                          return;
                                        }
                                        const numValue = Number(value);
                                        if (numValue < 1) {
                                          return;
                                        }
                                        setEditIndex({
                                          ...editIndex,
                                          proposalworkamount: numValue,
                                        });
                                      }}
                                      // onBlur={() => {
                                      //     if (!editIndex.proposalworkamount || editIndex.proposalworkamount < 1
                                      //     ) { setEditIndex({ ...editIndex, proposalworkamount: 1 }); }
                                      // }}
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="col-12 my-4 text-center">
                                <button
                                  className="btn btn-success px-5 fw-bold"
                                  onClick={(e) => handelchangeTablre(e)}
                                >
                                  {t("Submit")}
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-5">
                        <label>{t("Proposal Amount")}</label>
                      </div>
                      <div className="col-7">
                        <input
                          type="number"
                          placeholder={t("Enter Proposal Amount")}
                          className="form-control py-2"
                          name="TotalProposalAmount"
                          min="0"
                          onKeyDown={(e) => {
                            if (
                              ["e", "E", "+", "-"].includes(e.key) ||
                              (e.key === "." && e.target.value.includes(".")) // prevent multiple dots
                            ) {
                              e.preventDefault();
                            }
                          }}
                          value={Number(data.TotalProposalAmount || 0).toFixed(
                            2,
                          )}
                          // onChange={HandleChangeData}
                          disabled
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-5">
                        <label>
                          {t("Proposal File Number")}
                          <span className="text-danger fw-bold">*</span>
                        </label>
                      </div>
                      <div className="col-7">
                        <input
                          type="text"
                          placeholder={t("Enter Proposal File Number")}
                          className="form-control py-2"
                          name="ProposalFileNumber"
                          value={data.ProposalFileNumber}
                          onChange={HandleChangeData}
                          onBlur={(e) => {
                            const value = e.target.value.trim();

                            // Check if at least ONE valid character exists
                            const hasValidChar =
                              /[a-zA-Z0-9\u0900-\u097F]/.test(value);
                            if (value && !hasValidChar) {
                              setError("Enter at least one valid character");
                              alert("Enter at least one valid character");
                              setTimeout(() => e.target.focus(), 0);
                            } else {
                              setError("");
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* 
                                    <div className="col-12 elements">
                                        <div className="row">
                                            <div className="col-5">
                                                <label>Choose Area <span className='text-danger fw-bold'>*</span></label>
                                            </div>
                                            <div className="col-7">
                                                {
                                                    diableChoosebutton ? (
                                                        <>
                                                            <p>({locationData.StartCoordinates[0]} , {locationData.StartCoordinates[1]})</p>
                                                            <p>({locationData.StartCoordinates[0]} , {locationData.StartCoordinates[1]})</p>
                                                        </>
                                                    ) : (

                                                        <button className='btn btn-success w-100'
                                                            onClick={(e) => navigatetoMap(e)}
                                                        >Choose Area</button>
                                                    )
                                                }
                                            </div>





                                        </div>
                                    </div> */}

                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-5">
                        <label>
                          {t("Proposal Copy")}
                          <span className="text-danger fw-bold">*</span>
                        </label>
                      </div>
                      <div className="col-7">
                        <input
                          type="file"
                          className="form-control py-2"
                          id="ProposalCopy"
                          accept=".pdf,.jpg,.jpeg,.png"
                          required
                          onChange={handleFileUpload}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-5">
                        <label>
                          {t("Additional Supporting Document")}
                          <span className="text-danger fw-bold">*</span>
                        </label>
                      </div>
                      <div className="col-7">
                        <input
                          type="file"
                          className="form-control py-2"
                          id="AdditionalSupportingDocument"
                          accept=".pdf,.jpg,.jpeg,.png"
                          required
                          onChange={handleFileUpload}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 ms-auto my-4">
                    <div className="row">
                      <div className="col-5"></div>
                      <div className="col-7">
                        <div
                          className="col-12"
                          style={{ display: "flex", gap: "10px" }}
                        >
                          <button
                            onClick={handleSubmit}
                            disabled={isSubmitting}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "4px",
                              background: isSubmitting
                                ? "#9ca3af"
                                : "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                              width: "7rem",
                              height: "2rem",
                              fontSize: "18px",
                              cursor: isSubmitting ? "not-allowed" : "pointer",
                              opacity: isSubmitting ? 0.7 : 1,
                            }}
                          >
                            {isSubmitting ? (
                              "Saving..."
                            ) : (
                              <>
                                <img src={submit} style={{ width: "15px" }} />
                                {t("Save")}
                              </>
                            )}
                          </button>
                          <button
                            type="button"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "4px",
                              backgroundColor: "#f1594c",
                              width: "6rem",
                              height: "2rem",
                              fontSize: "16px",
                            }}
                            onClick={() => CancelMapSubmission()}
                          >
                            {" "}
                            <img src={Cancel32} style={{ width: "17px" }} />
                            {t("Cancel")}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateProposal;
